<script lang="ts">
    import cx from 'classnames';
    import Logo from '$lib/icons/casumoLogo.svg';
    import { CASUMO_LOGO_TESTID } from './constants';
    export let href: string;
    export let size: 'small' | 'large' = 'small';
</script>

<a
    class={cx(
        'block flex-shrink-0 items-center justify-center text-white desktop-l:w-[150px]',
        size === 'small' ? 'w-[100px]' : 'w-[120px]'
    )}
    {href}
    data-testid={CASUMO_LOGO_TESTID}
>
    <Logo></Logo>
</a>
